import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { BrowserService } from '../services/browser.service';
import { StorageService } from '../services/storage.service';

export const promoSaveGuard: CanActivateFn = route => {
  const browserService = inject(BrowserService);
  const storage = inject(StorageService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) return of(true);
  const loggedIn = browserService.getCookies()?.['picflow-loggedin'] === 'true';
  if (loggedIn) return of(true);

  const promoCode = route.queryParams.promo;
  if (promoCode) storage.set('promo', promoCode);
  return of(true);
};
